import { Box, Button, Flex, FormControl, FormLabel, Input, Textarea, VStack, Text, useToast } from '@chakra-ui/react';
import {useLanguage} from '../components/LanguageContext';

const ContactUs = () => {
  const toast = useToast();
  const {language} = useLanguage();
  const isEnglish = language === 'en';

  const translations = {
    en: {
      title: "Contact Us",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Your Email",
      subjectPlaceholder: "Your Subject",
      messagePlaceholder: "Your Message",
      button: "Send Message",
      toastTitle: "Form submitted.",
      toastDesc: "We've received your message."
    },
    es: {
      title: "Contáctanos",
      name: "Nombre",
      email: "Correo Electrónico",
      subject: "Asunto",
      message: "Mensaje",
      namePlaceholder: "Tu nombre",
      emailPlaceholder: "Tu correo electrónico",
      subjectPlaceholder: "Tu asunto",
      messagePlaceholder: "Tu mensaje",
      button: "Enviar Mensaje",
      toastTitle: "Formulario enviado.",
      toastDesc: "Hemos recibido tu mensaje."
    }
  };

  const t = isEnglish ? translations.en : translations.es;

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: t.toastTitle,
      description: t.toastDesc,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    // Handle form submission here (e.g., send data to server)
  };

  return (

    <>
      <Flex w="100%" justify="space-around" px={8} pt={8}
        backgroundColor="cyan.50">
        <Box flex="1" p={4} mx={0} textAlign="center" fontSize={{ base: 24, lg: 40 }}>
          <Text>{t.title}</Text>
        </Box>
      </Flex>

      <Flex
        w="100%"
        align="center"
        justify="center"
        direction="column"
        p={8}
        backgroundColor="cyan.50"
      >
        <Box
          w={{ base: "90%", sm: "80%", md: "70%", lg: "60%", xl: "50%" }} // Adjusted for better responsiveness
          p={6}
          backgroundColor="white"
          boxShadow="lg"
          borderRadius="md"
        >
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel htmlFor="name">{t.name}</FormLabel>
                <Input id="name" type="text" placeholder={t.namePlaceholder}/>
              </FormControl>
              <FormControl isRequired>
                <FormLabel htmlFor="email">{t.email}</FormLabel>
                <Input id="email" type="email" placeholder={t.emailPlaceholder}/>
              </FormControl>
              <FormControl isRequired>
                <FormLabel htmlFor="subject">{t.subject}</FormLabel>
                <Input id="subject" type="text" placeholder={t.subjectPlaceholder} />
              </FormControl>
              <FormControl isRequired>
                <FormLabel htmlFor="message">{t.message}</FormLabel>
                <Textarea id="message" placeholder={t.messagePlaceholder}/>
              </FormControl>
              <Button
                type="submit"
                colorScheme="blue"
                width="full"
                backgroundColor="blue.500"
                _hover={{ backgroundColor: "blue.600" }}
              >
                {t.button}
              </Button>
            </VStack>
          </form>
        </Box>
      </Flex>
    </>
  );
};

export default ContactUs;